import { makeStyles } from '@material-ui/core';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    '& .slick-slider': {
      '& .slick-arrow': {
        [theme.breakpoints.down('md')]: {
          visibility: 'hidden',
        },
      },
      '& .slick-thumb': {
        [theme.breakpoints.down('md')]: {
          display: 'none !important',
        },
      },

      '& .location-info': {
        display: 'flex',
        ...theme.mixins.paddingLeft(pxToRem(24)),
        justifyContent: theme.isDirectionRTL ? 'flex-end' : '',
        [theme.breakpoints.up('lg')]: {
          ...theme.mixins.paddingLeft(0),
          paddingTop: pxToRem(26),
        },

        '& .locationIcon': {
          width: pxToRem(24),
          height: pxToRem(24),
          border: theme.borders.divider,
          borderColor: theme.mixins.White(),
          borderRadius: borderRadius.circle,
          marginRight: pxToRem(10),
          marginBottom: pxToRem(16),
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',

          [theme.breakpoints.up('lg')]: {
            width: pxToRem(28),
            height: pxToRem(28),
            marginBottom: pxToRem(0),
          },

          '& > svg': {
            width: pxToRem(14),
            height: pxToRem(14),
          },
        },
      },
    },
    '& .slider-wrapper': {
      '& .slick-slider': {
        '& .slick-arrow': {
          [theme.breakpoints.down('md')]: {
            visibility: 'visible',
          },
        },
        '& .slick-list': {
          '& .slick-track': {
            '& .slick-active': {
              '&.fullscreen': {
                height: '100vh',
              },
              [theme.breakpoints.down('md')]: {
                visibility: 'visible',
              },
            },
          },
        },
        '& .slide-content-wrapper': {
          display: 'flex',
          flexDirection: 'column-reverse',
          [theme.breakpoints.up('lg')]: {
            flexDirection: 'column',
          },
        },
      },
    },
    '& .slick-prev, & .slick-next': {
      zIndex: '100',
      width: 'auto',
      height: 'auto',
      transform: 'none',

      '&.slick-disabled': {
        opacity: '0.3',

        '& button': {
          cursor: 'default',
          '&:hover': {
            borderColor: theme.mixins.White(),
            backgroundColor: 'transparent',
            '& svg': {
              color: theme.mixins.White(),
            },
          },
        },
      },

      '& button': {
        color: theme.mixins.White(),
        borderColor: theme.mixins.White(),
        [theme.breakpoints.up('lg')]: {
          '&:hover': {
            borderColor: 'transparent',
            backgroundColor: theme.mixins.White(300),
            '& svg': {
              color: theme.mixins.Black(),
            },
          },
        },
        [theme.breakpoints.down('lg')]: {
          '&:active': {
            borderColor: 'transparent',
            backgroundColor: theme.mixins.White(300),
            '& svg': {
              color: theme.mixins.Black(),
            },
          },
        }
      },
    },
    '& .slick-prev > button, & .slick-next > button': {
      border: '1px solid #000',
      width: pxToRem(46),
      height: pxToRem(46),
      [theme.breakpoints.up('lg')]: {
        width: pxToRem(84),
        height: pxToRem(84),
      },
    },
    '& .slick-prev::before,& .slick-next::before': {
      content: "''",
    },
    '& .slick-next, & .slick-prev': {
      top: '80%',
      bottom: 'auto',
      '& svg': {
        [theme.breakpoints.down('md')]: {
          position: 'relative',
          top: pxToRem(1),
        },
      },
      [theme.breakpoints.up('lg')]: {
        top: '30%',
      },
    },
    '& .slick-prev': {
      left: pxToRem(25),
      right: 'auto',
      '& svg': {
        [theme.breakpoints.down('md')]: {
          ...theme.mixins.left(pxToRem(-1)),
        },
      },
      [theme.breakpoints.up('lg')]: {
        left: pxToRem(-117),
      },
    },
    '& .slick-next': {
      left: 'auto',
      right: pxToRem(25),
      '& svg': {
        [theme.breakpoints.down('md')]: {
          ...theme.mixins.right(pxToRem(-1)),
        },
      },
      [theme.breakpoints.up('lg')]: {
        right: pxToRem(-117),
      },
    },
    '& .slick-track': {
      display: 'flex',
    },
    '& .slick-thumb': {
      textAlign: theme.mixins.textLeft(),
      position: 'relative',
      bottom: 0,
      '& li': {
        width: pxToRem(107),
        height: pxToRem(104),
        overflow: 'hidden',
        margin: 0,
        '& > a': {
          display: 'flex',
          height: '100%',

          '& picture': {
            '& img': {
              backgroundSize: '80% auto'
            }
          }
        },

        '&.slick-active a': {
          border: theme.borders.divider,
          borderColor: theme.mixins.White(),
        },
      },
      [theme.breakpoints.up('lg')]: {
        marginTop: pxToRem(16),
      },
    },
  },
  thumbnails: {
    '& .thumbnailImg': {
      opacity: '0.65',
    },
  },
}));

export default useStyles;
